var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTwitter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 23,
    viewBox: "0 0 29 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28.1148 2.63888C27.0744 3.08818 25.9722 3.38476 24.8437 3.51907C26.0318 2.81861 26.9215 1.72012 27.3483 0.426473C26.2471 1.0568 25.0266 1.51564 23.7275 1.77118C22.8703 0.872168 21.7346 0.275899 20.4965 0.0749657C19.2584 -0.125968 17.9874 0.0796779 16.8807 0.659969C15.774 1.24026 14.8936 2.16272 14.3762 3.28411C13.8589 4.4055 13.7335 5.66307 14.0195 6.86153C9.28368 6.64233 5.08624 4.41175 2.27715 1.03977C1.76627 1.89135 1.4998 2.86265 1.50598 3.8507C1.50598 5.7928 2.51336 7.49981 4.03949 8.50266C3.135 8.47442 2.25048 8.23455 1.45966 7.80305V7.87233C1.45915 9.16296 1.91388 10.414 2.74669 11.4133C3.5795 12.4125 4.73912 13.0984 6.02878 13.3545C5.19312 13.5741 4.31787 13.6071 3.46748 13.451C3.83368 14.5617 4.54414 15.5326 5.49979 16.2283C6.45544 16.9239 7.60863 17.3097 8.79851 17.3318C6.78315 18.8831 4.29477 19.7251 1.73293 19.7226C1.28135 19.7226 0.830917 19.6964 0.378174 19.6465C2.99009 21.2868 6.02706 22.1576 9.12852 22.1553C19.6123 22.1553 25.3381 13.6418 25.3381 6.27095C25.3381 6.03358 25.3381 5.79394 25.3208 5.55544C26.4393 4.76593 27.4041 3.78575 28.1692 2.66159L28.1148 2.63888Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwitter);
export default __webpack_public_path__ + "static/media/twitter.476f829c14e6b381aa045ef1e2487825.svg";
export { ForwardRef as ReactComponent };